import { render, staticRenderFns } from "./AskueTable.vue?vue&type=template&id=656e85b3&"
import script from "./AskueTable.vue?vue&type=script&lang=ts&"
export * from "./AskueTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports